/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Category_ActiveInputs */

const vi_expense_category_active = /** @type {(inputs: Expense_Category_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang dùng`)
};

/**

* @param {Expense_Category_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_category_active = /** @type {((inputs?: Expense_Category_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Category_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_category_active(inputs)
});